import { render, staticRenderFns } from "./validations-commons.vue?vue&type=template&id=35ccc474&"
import script from "./validations-commons.vue?vue&type=script&lang=ts&"
export * from "./validations-commons.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports